import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { Instances } from '../../../../constants';
import { WhatsappTemplateFieldNameType } from '../../../../interface/whatsapTemplate';
import { getData } from '../../../../store/actions/SMSTemplates.action';
import { IStateType } from '../../../../store/models/root.interface';
import { localCreateInitialObject, makeSelectObject, requestLocalChangeObjectField, requestObject } from '../../../../store/Object';
import { makeSelectObjectsArray, requestObjects } from '../../../../store/Objects';
import { closeSideBar, getParams } from '../../../../store/sidebar';
import EditTemplateForm, { DispatchPropsType, MapStatePropsType } from '../organisms/templates/editTemplateForm';



const mapStateToProps = (state: IStateType) => ({
    templateViewObj: makeSelectObjectsArray(Instances.viewWhatsappTemplate)(state)?.[0] || {},
    template: makeSelectObject(Instances.whatsappTemplate)(state) || {},
    templateLayout: makeSelectObject(Instances.WhatsappTemplateLayout)(state) || {},
    countryList: makeSelectObject(Instances.countryList)(state) || [],
    data: state.whatsappNumbers,
    params: getParams(state)

});

const mapDispatchToProps = (dispatch: any) => ({
    onClose: () => dispatch(closeSideBar()),
    onLoad: () => dispatch((requestObject(Instances.WhatsappTemplateLayout))),
    loadTemplate: (id: string) => dispatch(requestObjects(Instances.viewWhatsappTemplate, { temp: id })),
    loadTemplateList: () => dispatch((requestObjects(Instances.whatsappTemplate))),
    fetchCountryList: () => dispatch(requestObject(Instances.countryList)),
    setTemplateState: (tempObj: Partial<Record<WhatsappTemplateFieldNameType, (string)>>) => dispatch(localCreateInitialObject(Instances.whatsappTemplate, tempObj)),
    onChange: (fields: { name: WhatsappTemplateFieldNameType; value: any }) => dispatch(requestLocalChangeObjectField(Instances.whatsappTemplate, fields)),
    onSave: (formData: any, callback: (resp: any, flag: boolean) => void) => dispatch(requestObject(Instances.editWhatsappTemplate, undefined, undefined, 'put', true, true, formData, (response: any, flag: boolean) => callback(response, flag))),
    onLoadData: () => dispatch(getData()),
});

export default connect<MapStatePropsType, DispatchPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(withImmutablePropsToJS(EditTemplateForm));